import isNull from "../../utils/NullChecking";
const UpdateReduxDropDowns = (ID, DropDown, value,  display) => {
    if (!isNull(display) && !isNull(value) && DropDown.length > 0) {
        if (ID === 0 || ID === null) {
            let obj = { value: value - "", display: display }
            DropDown.push(obj)
        }else{
            DropDown.map((item) => {
                if(item.value + "" ===  value + ""){
                    item.display =  display
                }
            })
        }
    }
    return null; // Return a default value if no match is found
};

export default UpdateReduxDropDowns;